import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs-compat/Observable'
import { OrderApiConfiguration } from '../../order-and-billing/order-api-configuration';
import { ServiceBase } from '../../../infrastructure/serviceBase.component';
import { CoverageClass } from "app/shared/models/orders-and-billing/coverage-class";

@Injectable()
export class CoverageClassService extends ServiceBase {
    private _actionUrl: string;
    private _url: string;
    private _getClassesByContractId: string;
    private _getActiveClassesByContractId: string;
    private _getPayerClassByPayerIdContainContract: string;
    private _getInfoByContract: string;
    private _getBySearch: string;
    private _activeClassesNamesUrl: string;

    constructor(private _http: HttpClient, private _configuration: OrderApiConfiguration) {
        super();
        this._actionUrl = _configuration.server;
        this._url = this._actionUrl + _configuration.coverageClass.url;
        this._getClassesByContractId = this._actionUrl + _configuration.coverageClass.getClassesByContractId;
        this._getActiveClassesByContractId = this._actionUrl + _configuration.coverageClass.getActiveClassesByContractId;
        this._getPayerClassByPayerIdContainContract = this._actionUrl + _configuration.coverageClass.getPayerClassByPayerIdContainContract;
        this._getInfoByContract = this._actionUrl + _configuration.coverageClass.getInfoByContract;
        this._getBySearch = this._actionUrl + _configuration.coverageClass.getBySearch;
        this._activeClassesNamesUrl = this._actionUrl + _configuration.coverageClass.activeClassesNames;
    }

    public getClassById = (id: number): Observable<CoverageClass> => {
        return this._http.get<any>(this._url + '?id=' + id)
    }

    public getClassesByContractId = (contractId: number): Observable<CoverageClass[]> => {
        return this._http.get<any>(this._getClassesByContractId + '?contractId=' + contractId)
    }

    public getPayerClassByPayerIdContainContract = (payerId: number, isActive?: boolean): Observable<CoverageClass[]> => {
        return this._http.get<any>(this._getPayerClassByPayerIdContainContract + '?payerId=' + payerId + '&isActive=' + isActive)
    }

    public add = (data: CoverageClass): Observable<any> => {
        return this._http.post<any>(this._url, JSON.stringify(data))
    }

    public update = (data: CoverageClass): Observable<any> => {
        return this._http.put<any>(this._url, data)
    }

    public getInfoByContract = (contractId: number): Observable<any[]> => {
        return this._http.get<any>(this._getInfoByContract + '?contractId=' + contractId)
    }

    public getBySearch = (query: string, payerId: number): Observable<any[]> => {
        return this._http.get<any>(this._getBySearch + '?query=' + query + '&payerId=' + payerId)
    }


    public getActiveClassesByContractId = (contractId: number): Observable<CoverageClass[]> => {
        return this._http.get<any>(this._getActiveClassesByContractId + '?contractId=' + contractId)
    }

    public getAllActiveCoverageClassNames = (): Observable<any> => {
        return this._http.get<any>(this._activeClassesNamesUrl);
    }
}
